import axios from 'axios';

// Base API URL - Update this to your backend URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/edu-consultancy/backend/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API Service
const apiService = {
  // Colleges
  getColleges: (params = {}) => api.get('/colleges.php', { params: { action: 'list', ...params } }),
  getCollegeDetails: (slug) => api.get('/colleges.php', { params: { action: 'details', slug } }),
  searchColleges: (query) => api.get('/colleges.php', { params: { action: 'search', q: query } }),
  getFeaturedColleges: (limit = 6) => api.get('/colleges.php', { params: { action: 'featured', limit } }),

  // Consultation
  submitConsultation: (data) => api.post('/consultation.php', data),
  getConsultation: (id) => api.get('/consultation.php', { params: { id } }),

  // Payment
  uploadPayment: (formData) => {
    return axios.post(`${API_BASE_URL}/payment.php?action=upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getPaymentDetails: (paymentId) => api.get('/payment.php', { params: { payment_id: paymentId } }),
  verifyPayment: (data) => api.post('/payment.php?action=verify', data),

  // Blogs
  getBlogs: (params = {}) => api.get('/blogs.php', { params }),
  getBlogDetails: (slug) => api.get('/blogs.php', { params: { action: 'details', slug } }),
  getFeaturedBlogs: (limit = 3) => api.get('/blogs.php', { params: { action: 'featured', limit } }),
  getBlogCategories: () => api.get('/blogs.php', { params: { action: 'categories' } }),

  // Team
  getTeamMembers: () => api.get('/general.php', { params: { endpoint: 'team' } }),

  // Testimonials
  getTestimonials: (limit = 10) => api.get('/general.php', { params: { endpoint: 'testimonials', limit } }),

  // Contact
  submitContact: (data) => api.post('/general.php?endpoint=contact', data),

  // Settings
  getSettings: () => api.get('/general.php', { params: { endpoint: 'settings' } }),

  // Admin Auth
  adminLogin: (credentials) => api.post('/auth.php?action=login', credentials),
  adminLogout: () => api.post('/auth.php?action=logout'),
  verifyToken: () => api.get('/auth.php', { params: { action: 'verify' } }),

  // Student Auth
  studentRegister: (data) => api.post('/student-auth.php?action=register', data),
  studentLogin: (credentials) => api.post('/student-auth.php?action=login', credentials),
  studentLogout: () => api.post('/student-auth.php?action=logout'),
  verifyStudentToken: () => api.get('/student-auth.php', { params: { action: 'verify' } }),
  getStudentProfile: () => api.get('/student-auth.php', { params: { action: 'profile' } }),
  updateStudentProfile: (data) => api.post('/student-auth.php?action=update-profile', data),

  // Applications
  applyToCollege: (data) => api.post('/applications.php?action=apply', data),
  getMyApplications: () => api.get('/applications.php', { params: { action: 'my-applications' } }),
  getApplicationDetails: (id) => api.get('/applications.php', { params: { action: 'details', id } }),
  uploadApplicationDocument: (formData) => {
    return axios.post(`${API_BASE_URL}/applications.php?action=upload-documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // Admin - Applications
  getAllApplications: (params = {}) => api.get('/applications.php', { params: { action: 'all', ...params } }),
  updateApplicationStatus: (data) => api.put('/applications.php?action=update-status', data),
};

export default apiService;
